export const FakeData = [
    {
        'invoice': 'test invoce data' ,
        'package':'test package data' ,
        'price':1200 ,
        'Invoice_Date':'7/24/2023' ,
        'status': 0,
    },
    {
        'invoice': 'test invoce data' ,
        'package':'test package data' ,
        'price':1200 ,
        'Invoice_Date':'7/24/2023' ,
        'status': 1,
    },
    {
        'invoice': 'test invoce data' ,
        'package':'test package data' ,
        'price':1200 ,
        'Invoice_Date':'7/24/2023' ,
        'status': 1,
    },
    {
        'invoice': 'test invoce data' ,
        'package':'test package data' ,
        'price':1200 ,
        'Invoice_Date':'7/24/2023' ,
        'status': 0,
    },
    {
        'invoice': 'test invoce data' ,
        'package':'test package data' ,
        'price':1200 ,
        'Invoice_Date':'7/24/2023' ,
        'status': 1,
    },
]



export const TicketFakeData = [
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 0,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 0,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 1,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 1,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 1,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 0,
    },
    {
        'title': 'ticket title' ,
        'date':'7/24/2023' ,
        'status': 0,
    },
]